export default __webpack_public_path__ + "static/media/pwa1.1010544e.jpg";